{
  "autocomplete": {
    "dropdown": {
      "background": {
        "$type": "color",
        "$value": "{surface.100}"
      },
      "color": {
        "$type": "color",
        "$value": "{surface.950}"
      },
      "hover": {
        "background": {
          "$type": "color",
          "$value": "{surface.200}"
        },
        "color": {
          "$type": "color",
          "$value": "{surface.950}"
        }
      },
      "active": {
        "background": {
          "$type": "color",
          "$value": "{surface.300}"
        },
        "color": {
          "$type": "color",
          "$value": "{surface.950}"
        }
      }
    },
    "chip": {
      "focus": {
        "background": {
          "$type": "color",
          "$value": "{surface.200}"
        },
        "color": {
          "$type": "color",
          "$value": "{surface.800}"
        }
      }
    }
  },
  "badge": {
    "primary": {
      "background": {
        "$type": "color",
        "$value": "{primary.color}"
      },
      "color": {
        "$type": "color",
        "$value": "{primary.contrast.color}"
      }
    },
    "secondary": {
      "background": {
        "$type": "color",
        "$value": "{surface.100}"
      },
      "color": {
        "$type": "color",
        "$value": "{surface.600}"
      }
    },
    "success": {
      "background": {
        "$type": "color",
        "$value": "{green.500}"
      },
      "color": {
        "$type": "color",
        "$value": "{surface.0}"
      }
    },
    "info": {
      "background": {
        "$type": "color",
        "$value": "{sky.500}"
      },
      "color": {
        "$type": "color",
        "$value": "{surface.0}"
      }
    },
    "warn": {
      "background": {
        "$type": "color",
        "$value": "{orange.500}"
      },
      "color": {
        "$type": "color",
        "$value": "{surface.0}"
      }
    },
    "danger": {
      "background": {
        "$type": "color",
        "$value": "{red.500}"
      },
      "color": {
        "$type": "color",
        "$value": "{surface.0}"
      }
    },
    "contrast": {
      "background": {
        "$type": "color",
        "$value": "{surface.950}"
      },
      "color": {
        "$type": "color",
        "$value": "{surface.0}"
      }
    }
  },
  "carousel": {
    "indicator": {
      "background": {
        "$type": "color",
        "$value": "{surface.200}"
      },
      "hover": {
        "background": {
          "$type": "color",
          "$value": "{surface.300}"
        }
      }
    },
    "figma": {
      "item": {
        "tag": {
          "background": {
            "$type": "color",
            "$value": "rgba(0, 0, 0, 0.0000)"
          }
        }
      }
    }
  },
  "button": {
    "primary": {
      "background": {
        "$type": "color",
        "$value": "{primary.color}"
      },
      "color": {
        "$type": "color",
        "$value": "{primary.contrast.color}"
      },
      "hover": {
        "background": {
          "$type": "color",
          "$value": "{primary.hover.color}"
        },
        "color": {
          "$type": "color",
          "$value": "{primary.contrast.color}"
        },
        "border": {
          "color": {
            "$type": "color",
            "$value": "{primary.hover.color}"
          }
        }
      },
      "active": {
        "background": {
          "$type": "color",
          "$value": "{primary.active.color}"
        },
        "color": {
          "$type": "color",
          "$value": "{primary.contrast.color}"
        },
        "border": {
          "color": {
            "$type": "color",
            "$value": "{primary.active.color}"
          }
        }
      },
      "border": {
        "color": {
          "$type": "color",
          "$value": "{primary.color}"
        }
      },
      "focus": {
        "ring": {
          "color": {
            "$type": "color",
            "$value": "{primary.color}"
          }
        }
      }
    },
    "secondary": {
      "background": {
        "$type": "color",
        "$value": "{surface.100}"
      },
      "color": {
        "$type": "color",
        "$value": "{surface.950}"
      },
      "hover": {
        "background": {
          "$type": "color",
          "$value": "{surface.200}"
        },
        "color": {
          "$type": "color",
          "$value": "{surface.950}"
        },
        "border": {
          "color": {
            "$type": "color",
            "$value": "{surface.200}"
          }
        }
      },
      "active": {
        "background": {
          "$type": "color",
          "$value": "{surface.300}"
        },
        "color": {
          "$type": "color",
          "$value": "{surface.950}"
        },
        "border": {
          "color": {
            "$type": "color",
            "$value": "{surface.300}"
          }
        }
      },
      "border": {
        "color": {
          "$type": "color",
          "$value": "{surface.100}"
        }
      },
      "focus": {
        "ring": {
          "color": {
            "$type": "color",
            "$value": "{surface.600}"
          }
        }
      }
    },
    "info": {
      "background": {
        "$type": "color",
        "$value": "{colours.functional.informational.standard}"
      },
      "color": {
        "$type": "color",
        "$value": "#ffffff"
      },
      "hover": {
        "background": {
          "$type": "color",
          "$value": "{colours.functional.informational.hovered}"
        },
        "color": {
          "$type": "color",
          "$value": "#ffffff"
        },
        "border": {
          "color": {
            "$type": "color",
            "$value": "{colours.functional.informational.hovered}"
          }
        }
      },
      "active": {
        "background": {
          "$type": "color",
          "$value": "{colours.functional.informational.pressed}"
        },
        "color": {
          "$type": "color",
          "$value": "#ffffff"
        },
        "border": {
          "color": {
            "$type": "color",
            "$value": "{colours.functional.informational.pressed}"
          }
        }
      },
      "border": {
        "color": {
          "$type": "color",
          "$value": "{colours.functional.informational.standard}"
        }
      },
      "focus": {
        "ring": {
          "color": {
            "$type": "color",
            "$value": "{sky.500}"
          }
        }
      }
    },
    "success": {
      "background": {
        "$type": "color",
        "$value": "{colours.functional.success.standard}"
      },
      "color": {
        "$type": "color",
        "$value": "#ffffff"
      },
      "hover": {
        "background": {
          "$type": "color",
          "$value": "{colours.functional.success.hovered}"
        },
        "color": {
          "$type": "color",
          "$value": "#ffffff"
        },
        "border": {
          "color": {
            "$type": "color",
            "$value": "{colours.functional.success.hovered}"
          }
        }
      },
      "active": {
        "background": {
          "$type": "color",
          "$value": "{colours.functional.success.pressed}"
        },
        "color": {
          "$type": "color",
          "$value": "#ffffff"
        },
        "border": {
          "color": {
            "$type": "color",
            "$value": "{colours.functional.success.pressed}"
          }
        }
      },
      "border": {
        "color": {
          "$type": "color",
          "$value": "{colours.functional.success.standard}"
        }
      },
      "focus": {
        "ring": {
          "color": {
            "$type": "color",
            "$value": "{green.500}"
          }
        }
      }
    },
    "warn": {
      "background": {
        "$type": "color",
        "$value": "{colours.functional.warning.standard}"
      },
      "color": {
        "$type": "color",
        "$value": "#ffffff"
      },
      "hover": {
        "background": {
          "$type": "color",
          "$value": "{colours.functional.warning.hovered}"
        },
        "color": {
          "$type": "color",
          "$value": "#ffffff"
        },
        "border": {
          "color": {
            "$type": "color",
            "$value": "{colours.functional.warning.hovered}"
          }
        }
      },
      "active": {
        "background": {
          "$type": "color",
          "$value": "{colours.functional.warning.pressed}"
        },
        "color": {
          "$type": "color",
          "$value": "#ffffff"
        },
        "border": {
          "color": {
            "$type": "color",
            "$value": "{colours.functional.warning.pressed}"
          }
        }
      },
      "border": {
        "color": {
          "$type": "color",
          "$value": "{colours.functional.warning.standard}"
        }
      },
      "focus": {
        "ring": {
          "color": {
            "$type": "color",
            "$value": "{orange.500}"
          }
        }
      }
    },
    "help": {
      "background": {
        "$type": "color",
        "$value": "{purple.500}"
      },
      "color": {
        "$type": "color",
        "$value": "#ffffff"
      },
      "hover": {
        "background": {
          "$type": "color",
          "$value": "{purple.600}"
        },
        "color": {
          "$type": "color",
          "$value": "#ffffff"
        },
        "border": {
          "color": {
            "$type": "color",
            "$value": "{purple.600}"
          }
        }
      },
      "active": {
        "background": {
          "$type": "color",
          "$value": "{purple.700}"
        },
        "color": {
          "$type": "color",
          "$value": "#ffffff"
        },
        "border": {
          "color": {
            "$type": "color",
            "$value": "{purple.700}"
          }
        }
      },
      "border": {
        "color": {
          "$type": "color",
          "$value": "{purple.500}"
        }
      },
      "focus": {
        "ring": {
          "color": {
            "$type": "color",
            "$value": "{purple.500}"
          }
        }
      }
    },
    "danger": {
      "background": {
        "$type": "color",
        "$value": "{colours.functional.destructive.standard}"
      },
      "color": {
        "$type": "color",
        "$value": "#ffffff"
      },
      "hover": {
        "background": {
          "$type": "color",
          "$value": "{colours.functional.destructive.hovered}"
        },
        "color": {
          "$type": "color",
          "$value": "#ffffff"
        },
        "border": {
          "color": {
            "$type": "color",
            "$value": "{colours.functional.destructive.hovered}"
          }
        }
      },
      "active": {
        "background": {
          "$type": "color",
          "$value": "{colours.functional.destructive.pressed}"
        },
        "color": {
          "$type": "color",
          "$value": "#ffffff"
        },
        "border": {
          "color": {
            "$type": "color",
            "$value": "{colours.functional.destructive.pressed}"
          }
        }
      },
      "border": {
        "color": {
          "$type": "color",
          "$value": "{colours.functional.destructive.standard}"
        }
      },
      "focus": {
        "ring": {
          "color": {
            "$type": "color",
            "$value": "{red.500}"
          }
        }
      }
    },
    "contrast": {
      "background": {
        "$type": "color",
        "$value": "{surface.950}"
      },
      "color": {
        "$type": "color",
        "$value": "{surface.0}"
      },
      "hover": {
        "background": {
          "$type": "color",
          "$value": "{surface.800}"
        },
        "color": {
          "$type": "color",
          "$value": "{surface.0}"
        },
        "border": {
          "color": {
            "$type": "color",
            "$value": "{surface.800}"
          }
        }
      },
      "active": {
        "background": {
          "$type": "color",
          "$value": "{surface.700}"
        },
        "color": {
          "$type": "color",
          "$value": "{surface.0}"
        },
        "border": {
          "color": {
            "$type": "color",
            "$value": "{surface.700}"
          }
        }
      },
      "border": {
        "color": {
          "$type": "color",
          "$value": "{surface.950}"
        }
      },
      "focus": {
        "ring": {
          "color": {
            "$type": "color",
            "$value": "{surface.950}"
          }
        }
      }
    },
    "outlined": {
      "primary": {
        "color": {
          "$type": "color",
          "$value": "{primary.color}"
        },
        "hover": {
          "background": {
            "$type": "color",
            "$value": "{primary.50}"
          }
        },
        "active": {
          "background": {
            "$type": "color",
            "$value": "{primary.100}"
          }
        },
        "border": {
          "color": {
            "$type": "color",
            "$value": "{primary.200}"
          }
        }
      },
      "secondary": {
        "color": {
          "$type": "color",
          "$value": "{surface.950}"
        },
        "hover": {
          "background": {
            "$type": "color",
            "$value": "{surface.200}"
          }
        },
        "active": {
          "background": {
            "$type": "color",
            "$value": "{surface.300}"
          }
        },
        "border": {
          "color": {
            "$type": "color",
            "$value": "{surface.950}"
          }
        }
      },
      "success": {
        "color": {
          "$type": "color",
          "$value": "{green.500}"
        },
        "hover": {
          "background": {
            "$type": "color",
            "$value": "{green.50}"
          }
        },
        "active": {
          "background": {
            "$type": "color",
            "$value": "{green.100}"
          }
        },
        "border": {
          "color": {
            "$type": "color",
            "$value": "{green.200}"
          }
        }
      },
      "info": {
        "color": {
          "$type": "color",
          "$value": "{sky.500}"
        },
        "hover": {
          "background": {
            "$type": "color",
            "$value": "{sky.50}"
          }
        },
        "active": {
          "background": {
            "$type": "color",
            "$value": "{sky.100}"
          }
        },
        "border": {
          "color": {
            "$type": "color",
            "$value": "{sky.200}"
          }
        }
      },
      "warn": {
        "color": {
          "$type": "color",
          "$value": "{orange.500}"
        },
        "hover": {
          "background": {
            "$type": "color",
            "$value": "{orange.50}"
          }
        },
        "active": {
          "background": {
            "$type": "color",
            "$value": "{orange.100}"
          }
        },
        "border": {
          "color": {
            "$type": "color",
            "$value": "{orange.200}"
          }
        }
      },
      "help": {
        "color": {
          "$type": "color",
          "$value": "{purple.500}"
        },
        "hover": {
          "background": {
            "$type": "color",
            "$value": "{purple.50}"
          }
        },
        "active": {
          "background": {
            "$type": "color",
            "$value": "{purple.100}"
          }
        },
        "border": {
          "color": {
            "$type": "color",
            "$value": "{purple.200}"
          }
        }
      },
      "danger": {
        "color": {
          "$type": "color",
          "$value": "{red.500}"
        },
        "hover": {
          "background": {
            "$type": "color",
            "$value": "{red.50}"
          }
        },
        "active": {
          "background": {
            "$type": "color",
            "$value": "{red.100}"
          }
        },
        "border": {
          "color": {
            "$type": "color",
            "$value": "{red.200}"
          }
        }
      },
      "contrast": {
        "color": {
          "$type": "color",
          "$value": "{surface.950}"
        },
        "hover": {
          "background": {
            "$type": "color",
            "$value": "{surface.200}"
          }
        },
        "active": {
          "background": {
            "$type": "color",
            "$value": "{surface.300}"
          }
        },
        "border": {
          "color": {
            "$type": "color",
            "$value": "{surface.950}"
          }
        }
      },
      "plain": {
        "color": {
          "$type": "color",
          "$value": "{surface.950}"
        },
        "hover": {
          "background": {
            "$type": "color",
            "$value": "{surface.50}"
          }
        },
        "active": {
          "background": {
            "$type": "color",
            "$value": "{surface.100}"
          }
        },
        "border": {
          "color": {
            "$type": "color",
            "$value": "{surface.200}"
          }
        }
      }
    },
    "text": {
      "primary": {
        "color": {
          "$type": "color",
          "$value": "{primary.color}"
        },
        "hover": {
          "background": {
            "$type": "color",
            "$value": "{primary.50}"
          }
        },
        "active": {
          "background": {
            "$type": "color",
            "$value": "{primary.100}"
          }
        }
      },
      "secondary": {
        "color": {
          "$type": "color",
          "$value": "{surface.950}"
        },
        "hover": {
          "background": {
            "$type": "color",
            "$value": "{surface.50}"
          }
        },
        "active": {
          "background": {
            "$type": "color",
            "$value": "{surface.100}"
          }
        }
      },
      "success": {
        "color": {
          "$type": "color",
          "$value": "{green.500}"
        },
        "hover": {
          "background": {
            "$type": "color",
            "$value": "{green.50}"
          }
        },
        "active": {
          "background": {
            "$type": "color",
            "$value": "{green.100}"
          }
        }
      },
      "info": {
        "color": {
          "$type": "color",
          "$value": "{sky.500}"
        },
        "hover": {
          "background": {
            "$type": "color",
            "$value": "{sky.50}"
          }
        },
        "active": {
          "background": {
            "$type": "color",
            "$value": "{sky.100}"
          }
        }
      },
      "warn": {
        "color": {
          "$type": "color",
          "$value": "{orange.500}"
        },
        "hover": {
          "background": {
            "$type": "color",
            "$value": "{orange.50}"
          }
        },
        "active": {
          "background": {
            "$type": "color",
            "$value": "{orange.100}"
          }
        }
      },
      "help": {
        "color": {
          "$type": "color",
          "$value": "{purple.500}"
        },
        "hover": {
          "background": {
            "$type": "color",
            "$value": "{purple.50}"
          }
        },
        "active": {
          "background": {
            "$type": "color",
            "$value": "{purple.100}"
          }
        }
      },
      "danger": {
        "color": {
          "$type": "color",
          "$value": "{red.500}"
        },
        "hover": {
          "background": {
            "$type": "color",
            "$value": "{red.50}"
          }
        },
        "active": {
          "background": {
            "$type": "color",
            "$value": "{red.100}"
          }
        }
      },
      "plain": {
        "color": {
          "$type": "color",
          "$value": "{surface.700}"
        },
        "hover": {
          "background": {
            "$type": "color",
            "$value": "{surface.50}"
          }
        },
        "active": {
          "background": {
            "$type": "color",
            "$value": "{surface.100}"
          }
        }
      },
      "contrast": {
        "color": {
          "$type": "color",
          "$value": "{surface.950}"
        },
        "hover": {
          "background": {
            "$type": "color",
            "$value": "{surface.50}"
          }
        },
        "active": {
          "background": {
            "$type": "color",
            "$value": "{surface.100}"
          }
        }
      }
    },
    "link": {
      "color": {
        "$type": "color",
        "$value": "{primary.color}"
      },
      "hover": {
        "color": {
          "$type": "color",
          "$value": "{primary.color}"
        }
      },
      "active": {
        "color": {
          "$type": "color",
          "$value": "{primary.color}"
        }
      }
    },
    "figma": {
      "raised": {
        "background": {
          "$type": "color",
          "$value": "rgba(255, 255, 255, 0.0100)"
        }
      }
    }
  },
  "chip": {
    "background": {
      "$type": "color",
      "$value": "{colours.basic.background-subtle}"
    },
    "color": {
      "$type": "color",
      "$value": "{colours.basic.text}"
    },
    "icon": {
      "color": {
        "$type": "color",
        "$value": "{colours.basic.text}"
      }
    },
    "remove": {
      "icon": {
        "color": {
          "$type": "color",
          "$value": "{colours.basic.text}"
        }
      }
    }
  },
  "colorpicker": {
    "panel": {
      "background": {
        "$type": "color",
        "$value": "{surface.800}"
      },
      "border": {
        "color": {
          "$type": "color",
          "$value": "{surface.900}"
        }
      }
    },
    "handle": {
      "color": {
        "$type": "color",
        "$value": "{surface.0}"
      }
    }
  },
  "datepicker": {
    "dropdown": {
      "background": {
        "$type": "color",
        "$value": "{surface.100}"
      },
      "color": {
        "$type": "color",
        "$value": "{surface.950}"
      },
      "hover": {
        "background": {
          "$type": "color",
          "$value": "{surface.200}"
        },
        "color": {
          "$type": "color",
          "$value": "{surface.950}"
        }
      },
      "active": {
        "background": {
          "$type": "color",
          "$value": "{surface.300}"
        },
        "color": {
          "$type": "color",
          "$value": "{surface.950}"
        }
      }
    },
    "today": {
      "background": {
        "$type": "color",
        "$value": "{surface.200}"
      },
      "color": {
        "$type": "color",
        "$value": "{surface.950}"
      }
    }
  },
  "datatable": {
    "border": {
      "color": {
        "$type": "color",
        "$value": "{content.border.color}"
      }
    },
    "row": {
      "striped": {
        "background": {
          "$type": "color",
          "$value": "{surface.100}"
        }
      }
    },
    "body": {
      "cell": {
        "selected": {
          "border": {
            "color": {
              "$type": "color",
              "$value": "{primary.100}"
            }
          }
        }
      }
    }
  },
  "galleria": {
    "thumbnail": {
      "nav": {
        "button": {
          "color": {
            "$type": "color",
            "$value": "{surface.600}"
          },
          "hover": {
            "background": {
              "$type": "color",
              "$value": "{surface.100}"
            },
            "color": {
              "$type": "color",
              "$value": "{surface.700}"
            }
          }
        }
      }
    },
    "indicator": {
      "button": {
        "background": {
          "$type": "color",
          "$value": "{surface.200}"
        },
        "hover": {
          "background": {
            "$type": "color",
            "$value": "{surface.300}"
          }
        }
      }
    }
  },
  "inputnumber": {
    "button": {
      "background": {
        "$type": "color",
        "$value": "rgba(0, 0, 0, 0.0000)"
      },
      "color": {
        "$type": "color",
        "$value": "{surface.950}"
      },
      "hover": {
        "background": {
          "$type": "color",
          "$value": "{surface.200}"
        },
        "color": {
          "$type": "color",
          "$value": "{surface.950}"
        },
        "border": {
          "color": {
            "$type": "color",
            "$value": "{form.field.border.color}"
          }
        }
      },
      "active": {
        "background": {
          "$type": "color",
          "$value": "{surface.300}"
        },
        "color": {
          "$type": "color",
          "$value": "{surface.950}"
        },
        "border": {
          "color": {
            "$type": "color",
            "$value": "{form.field.border.color}"
          }
        }
      },
      "border": {
        "color": {
          "$type": "color",
          "$value": "{form.field.border.color}"
        }
      }
    }
  },
  "listbox": {
    "option": {
      "striped": {
        "background": {
          "$type": "color",
          "$value": "{surface.50}"
        }
      }
    }
  },
  "message": {
    "info": {
      "background": {
        "$type": "color",
        "$value": "{colours.functional.informational.subtle}"
      },
      "color": {
        "$type": "color",
        "$value": "{text.color}"
      },
      "icon": {
        "$type": "color",
        "$value": "{colours.basic.text}"
      },
      "border": {
        "color": {
          "$type": "color",
          "$value": "{colours.functional.informational.subtle}"
        }
      },
      "close": {
        "button": {
          "hover": {
            "background": {
              "$type": "color",
              "$value": "{blue.100}"
            }
          },
          "focus": {
            "ring": {
              "color": {
                "$type": "color",
                "$value": "{blue.600}"
              }
            }
          }
        }
      },
      "outlined": {
        "color": {
          "$type": "color",
          "$value": "{colours.functional.informational.standard}"
        },
        "border": {
          "color": {
            "$type": "color",
            "$value": "{colours.functional.informational.standard}"
          }
        }
      },
      "simple": {
        "color": {
          "$type": "color",
          "$value": "{blue.600}"
        }
      }
    },
    "success": {
      "background": {
        "$type": "color",
        "$value": "{colours.functional.success.subtle}"
      },
      "color": {
        "$type": "color",
        "$value": "{text.color}"
      },
      "icon": {
        "$type": "color",
        "$value": "{colours.basic.text}"
      },
      "border": {
        "color": {
          "$type": "color",
          "$value": "{colours.functional.success.subtle}"
        }
      },
      "close": {
        "button": {
          "hover": {
            "background": {
              "$type": "color",
              "$value": "{green.100}"
            }
          },
          "focus": {
            "ring": {
              "color": {
                "$type": "color",
                "$value": "{green.600}"
              }
            }
          }
        }
      },
      "outlined": {
        "color": {
          "$type": "color",
          "$value": "{colours.functional.success.standard}"
        },
        "border": {
          "color": {
            "$type": "color",
            "$value": "{colours.functional.success.standard}"
          }
        }
      },
      "simple": {
        "color": {
          "$type": "color",
          "$value": "{green.600}"
        }
      }
    },
    "warn": {
      "background": {
        "$type": "color",
        "$value": "{colours.functional.warning.subtle}"
      },
      "color": {
        "$type": "color",
        "$value": "{text.color}"
      },
      "icon": {
        "$type": "color",
        "$value": "{colours.basic.text}"
      },
      "border": {
        "color": {
          "$type": "color",
          "$value": "{colours.functional.warning.subtle}"
        }
      },
      "close": {
        "button": {
          "hover": {
            "background": {
              "$type": "color",
              "$value": "{yellow.100}"
            }
          },
          "focus": {
            "ring": {
              "color": {
                "$type": "color",
                "$value": "{yellow.600}"
              }
            }
          }
        }
      },
      "outlined": {
        "color": {
          "$type": "color",
          "$value": "{text.color}"
        },
        "border": {
          "color": {
            "$type": "color",
            "$value": "{yellow.600}"
          }
        }
      },
      "simple": {
        "color": {
          "$type": "color",
          "$value": "{yellow.600}"
        }
      }
    },
    "error": {
      "background": {
        "$type": "color",
        "$value": "{colours.functional.destructive.subtle}"
      },
      "color": {
        "$type": "color",
        "$value": "{text.color}"
      },
      "icon": {
        "$type": "color",
        "$value": "{colours.basic.text}"
      },
      "border": {
        "color": {
          "$type": "color",
          "$value": "{colours.functional.destructive.subtle}"
        }
      },
      "close": {
        "button": {
          "hover": {
            "background": {
              "$type": "color",
              "$value": "{red.100}"
            }
          },
          "focus": {
            "ring": {
              "color": {
                "$type": "color",
                "$value": "{red.600}"
              }
            }
          }
        }
      },
      "outlined": {
        "color": {
          "$type": "color",
          "$value": "{red.600}"
        },
        "border": {
          "color": {
            "$type": "color",
            "$value": "{red.600}"
          }
        }
      },
      "simple": {
        "color": {
          "$type": "color",
          "$value": "{red.600}"
        }
      }
    },
    "secondary": {
      "background": {
        "$type": "color",
        "$value": "{surface.100}"
      },
      "color": {
        "$type": "color",
        "$value": "{surface.600}"
      },
      "border": {
        "color": {
          "$type": "color",
          "$value": "{surface.200}"
        }
      },
      "close": {
        "button": {
          "hover": {
            "background": {
              "$type": "color",
              "$value": "{surface.200}"
            }
          },
          "focus": {
            "ring": {
              "color": {
                "$type": "color",
                "$value": "{surface.600}"
              }
            }
          }
        }
      },
      "outlined": {
        "color": {
          "$type": "color",
          "$value": "{surface.500}"
        },
        "border": {
          "color": {
            "$type": "color",
            "$value": "{surface.500}"
          }
        }
      },
      "simple": {
        "color": {
          "$type": "color",
          "$value": "{surface.500}"
        }
      }
    },
    "contrast": {
      "background": {
        "$type": "color",
        "$value": "{surface.950}"
      },
      "color": {
        "$type": "color",
        "$value": "{surface.50}"
      },
      "border": {
        "color": {
          "$type": "color",
          "$value": "{surface.950}"
        }
      },
      "close": {
        "button": {
          "hover": {
            "background": {
              "$type": "color",
              "$value": "{surface.800}"
            }
          },
          "focus": {
            "ring": {
              "color": {
                "$type": "color",
                "$value": "{surface.50}"
              }
            }
          }
        }
      },
      "outlined": {
        "color": {
          "$type": "color",
          "$value": "{surface.950}"
        },
        "border": {
          "color": {
            "$type": "color",
            "$value": "{surface.950}"
          }
        }
      },
      "simple": {
        "color": {
          "$type": "color",
          "$value": "{surface.950}"
        }
      }
    }
  },
  "password": {
    "strength": {
      "weak": {
        "background": {
          "$type": "color",
          "$value": "{red.500}"
        }
      },
      "medium": {
        "background": {
          "$type": "color",
          "$value": "{amber.500}"
        }
      },
      "strong": {
        "background": {
          "$type": "color",
          "$value": "{green.500}"
        }
      }
    }
  },
  "progressspinner": {
    "color": {
      "one": {
        "$type": "color",
        "$value": "{red.500}"
      },
      "two": {
        "$type": "color",
        "$value": "{blue.500}"
      },
      "three": {
        "$type": "color",
        "$value": "{green.500}"
      },
      "four": {
        "$type": "color",
        "$value": "{yellow.500}"
      }
    }
  },
  "scrollpanel": {
    "bar": {
      "background": {
        "$type": "color",
        "$value": "{surface.100}"
      }
    }
  },
  "selectbutton": {
    "invalid": {
      "border": {
        "color": {
          "$type": "color",
          "$value": "{form.field.invalid.border.color}"
        }
      }
    }
  },
  "skeleton": {
    "background": {
      "$type": "color",
      "$value": "{surface.200}"
    }
  },
  "slider": {
    "handle": {
      "content": {
        "background": {
          "$type": "color",
          "$value": "{surface.0}"
        }
      }
    }
  },
  "tag": {
    "primary": {
      "background": {
        "$type": "color",
        "$value": "{primary.100}"
      },
      "color": {
        "$type": "color",
        "$value": "{primary.700}"
      }
    },
    "secondary": {
      "background": {
        "$type": "color",
        "$value": "{surface.100}"
      },
      "color": {
        "$type": "color",
        "$value": "{colours.basic.text}"
      }
    },
    "success": {
      "background": {
        "$type": "color",
        "$value": "{colours.functional.success.subtle}"
      },
      "color": {
        "$type": "color",
        "$value": "{colours.basic.text}"
      }
    },
    "info": {
      "background": {
        "$type": "color",
        "$value": "{colours.functional.informational.subtle}"
      },
      "color": {
        "$type": "color",
        "$value": "{colours.basic.text}"
      }
    },
    "warn": {
      "background": {
        "$type": "color",
        "$value": "{colours.functional.warning.subtle}"
      },
      "color": {
        "$type": "color",
        "$value": "{colours.basic.text}"
      }
    },
    "danger": {
      "background": {
        "$type": "color",
        "$value": "{colours.functional.destructive.subtle}"
      },
      "color": {
        "$type": "color",
        "$value": "{colours.basic.text}"
      }
    },
    "contrast": {
      "background": {
        "$type": "color",
        "$value": "{surface.950}"
      },
      "color": {
        "$type": "color",
        "$value": "{surface.0}"
      }
    },
    "figma": {
      "container": {
        "background": {
          "$type": "color",
          "$value": "rgba(0, 0, 0, 0.0000)"
        }
      }
    }
  },
  "togglebutton": {
    "background": {
      "$type": "color",
      "$value": "{surface.0}"
    },
    "color": {
      "$type": "color",
      "$value": "{text.color}"
    },
    "checked": {
      "background": {
        "$type": "color",
        "$value": "{surface.0}"
      },
      "color": {
        "$type": "color",
        "$value": "{surface.0}"
      },
      "border": {
        "color": {
          "$type": "color",
          "$value": "{surface.950}"
        }
      }
    },
    "hover": {
      "background": {
        "$type": "color",
        "$value": "{surface.200}"
      },
      "color": {
        "$type": "color",
        "$value": "{surface.950}"
      }
    },
    "border": {
      "color": {
        "$type": "color",
        "$value": "{surface.950}"
      }
    },
    "icon": {
      "color": {
        "$type": "color",
        "$value": "{surface.950}"
      },
      "hover": {
        "color": {
          "$type": "color",
          "$value": "{surface.950}"
        }
      },
      "checked": {
        "color": {
          "$type": "color",
          "$value": "{surface.0}"
        }
      }
    },
    "content": {
      "checked": {
        "background": {
          "$type": "color",
          "$value": "{primary.color}"
        }
      }
    }
  },
  "toast": {
    "blur": {
      "$type": "number",
      "$value": 1.5
    },
    "info": {
      "background": {
        "$type": "color",
        "$value": "{colours.functional.informational.subtle}"
      },
      "color": {
        "$type": "color",
        "$value": "{text.color}"
      },
      "border": {
        "color": {
          "$type": "color",
          "$value": "{colours.functional.informational.subtle}"
        }
      },
      "detail": {
        "color": {
          "$type": "color",
          "$value": "{surface.700}"
        }
      },
      "close": {
        "button": {
          "hover": {
            "background": {
              "$type": "color",
              "$value": "{blue.100}"
            }
          },
          "focus": {
            "ring": {
              "color": {
                "$type": "color",
                "$value": "{blue.600}"
              }
            }
          }
        }
      }
    },
    "success": {
      "background": {
        "$type": "color",
        "$value": "{colours.functional.success.subtle}"
      },
      "color": {
        "$type": "color",
        "$value": "{text.color}"
      },
      "border": {
        "color": {
          "$type": "color",
          "$value": "{colours.functional.success.subtle}"
        }
      },
      "detail": {
        "color": {
          "$type": "color",
          "$value": "{surface.700}"
        }
      },
      "close": {
        "button": {
          "hover": {
            "background": {
              "$type": "color",
              "$value": "{green.100}"
            }
          },
          "focus": {
            "ring": {
              "color": {
                "$type": "color",
                "$value": "{green.600}"
              }
            }
          }
        }
      }
    },
    "warn": {
      "background": {
        "$type": "color",
        "$value": "{colours.functional.warning.subtle}"
      },
      "color": {
        "$type": "color",
        "$value": "{text.color}"
      },
      "border": {
        "color": {
          "$type": "color",
          "$value": "{colours.functional.warning.subtle}"
        }
      },
      "detail": {
        "color": {
          "$type": "color",
          "$value": "{surface.700}"
        }
      },
      "close": {
        "button": {
          "hover": {
            "background": {
              "$type": "color",
              "$value": "{yellow.100}"
            }
          },
          "focus": {
            "ring": {
              "color": {
                "$type": "color",
                "$value": "{yellow.600}"
              }
            }
          }
        }
      }
    },
    "error": {
      "background": {
        "$type": "color",
        "$value": "{colours.functional.destructive.subtle}"
      },
      "color": {
        "$type": "color",
        "$value": "{text.color}"
      },
      "border": {
        "color": {
          "$type": "color",
          "$value": "{colours.functional.destructive.subtle}"
        }
      },
      "detail": {
        "color": {
          "$type": "color",
          "$value": "{surface.700}"
        }
      },
      "close": {
        "button": {
          "hover": {
            "background": {
              "$type": "color",
              "$value": "{red.100}"
            }
          },
          "focus": {
            "ring": {
              "color": {
                "$type": "color",
                "$value": "{red.600}"
              }
            }
          }
        }
      }
    },
    "secondary": {
      "background": {
        "$type": "color",
        "$value": "{colours.basic.background-subtle}"
      },
      "color": {
        "$type": "color",
        "$value": "{colours.basic.text}"
      },
      "border": {
        "color": {
          "$type": "color",
          "$value": "{colours.basic.background-subtle}"
        }
      },
      "detail": {
        "color": {
          "$type": "color",
          "$value": "{surface.700}"
        }
      },
      "close": {
        "button": {
          "hover": {
            "background": {
              "$type": "color",
              "$value": "{surface.200}"
            }
          },
          "focus": {
            "ring": {
              "color": {
                "$type": "color",
                "$value": "{surface.600}"
              }
            }
          }
        }
      }
    },
    "contrast": {
      "background": {
        "$type": "color",
        "$value": "{surface.900}"
      },
      "color": {
        "$type": "color",
        "$value": "{surface.50}"
      },
      "border": {
        "color": {
          "$type": "color",
          "$value": "{surface.950}"
        }
      },
      "detail": {
        "color": {
          "$type": "color",
          "$value": "{surface.0}"
        }
      },
      "close": {
        "button": {
          "hover": {
            "background": {
              "$type": "color",
              "$value": "{surface.800}"
            }
          },
          "focus": {
            "ring": {
              "color": {
                "$type": "color",
                "$value": "{surface.50}"
              }
            }
          }
        }
      }
    }
  },
  "toggleswitch": {
    "background": {
      "$type": "color",
      "$value": "{surface.0}"
    },
    "hover": {
      "background": {
        "$type": "color",
        "$value": "{surface.400}"
      }
    },
    "checked": {
      "background": {
        "$type": "color",
        "$value": "{primary.color}"
      },
      "hover": {
        "background": {
          "$type": "color",
          "$value": "{primary.hover.color}"
        }
      }
    },
    "handle": {
      "background": {
        "$type": "color",
        "$value": "{surface.950}"
      },
      "hover": {
        "background": {
          "$type": "color",
          "$value": "{surface.0}"
        },
        "color": {
          "$type": "color",
          "$value": "{text.color}"
        }
      },
      "checked": {
        "background": {
          "$type": "color",
          "$value": "{surface.0}"
        },
        "hover": {
          "background": {
            "$type": "color",
            "$value": "{surface.0}"
          },
          "color": {
            "$type": "color",
            "$value": "{primary.hover.color}"
          }
        },
        "color": {
          "$type": "color",
          "$value": "{primary.color}"
        }
      },
      "color": {
        "$type": "color",
        "$value": "{text.muted.color}"
      },
      "disabled": {
        "background": {
          "$type": "color",
          "$value": "{form.field.disabled.color}"
        }
      }
    },
    "disabled": {
      "background": {
        "$type": "color",
        "$value": "{form.field.disabled.background}"
      }
    }
  },
  "tooltip": {
    "background": {
      "$type": "color",
      "$value": "{surface.950}"
    },
    "color": {
      "$type": "color",
      "$value": "{surface.0}"
    }
  },
  "treetable": {
    "border": {
      "color": {
        "$type": "color",
        "$value": "{content.border.color}"
      }
    },
    "body": {
      "cell": {
        "selected": {
          "border": {
            "color": {
              "$type": "color",
              "$value": "{primary.100}"
            }
          }
        }
      }
    }
  }
}
